// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pergruzi-form input[type=number] {\n  width: 30px;\n}", ""]);
// Exports
module.exports = exports;
